module.exports = __webpack_public_path__ + "static/media/dropdown.7d32d2fa.svg";